import script from "./CalendarRytonEvent.vue?vue&type=script&setup=true&lang=js"
export * from "./CalendarRytonEvent.vue?vue&type=script&setup=true&lang=js"

import "./CalendarRytonEvent.vue?vue&type=style&index=0&id=2672ff98&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2672ff98"]])

export default __exports__